<template>
    <CadastroPadrao :cabecalho="state.cabecalho" :linhas="state.linhas" :url="state.url" :titulo="state.titulo"
        :limparInput="limparInput" :objeto="state.objetoAuxiliar" :lstObrigatorios="state.lstObrigatorios"
        :lstObrigatoriosLabel="state.lstObrigatoriosLabel">
        <template v-slot:ficha>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.id" disabled>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Descrição
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.descricao">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Ativo
                </label>
                <div class="col inp">
                    <input type="checkbox" class="form-check" v-model="state.objetoAuxiliar.ativo">
                </div>
            </div>
        </template>
    </CadastroPadrao>
</template>

<script setup>
import CadastroPadrao from '@/components/CadastroPadrao.vue';
import store from '@/store/store';
import { reactive, onMounted, computed } from 'vue';

const state = reactive({
    cabecalho: ['Código', "Descrição", "Ativo"],
    linhas: ['id', 'descricao', 'ativo'],
    url: "TipoAtendimento",
    titulo: "Cadastro de Tipo de Atendimento",
    objetoAuxiliar: {
        id: 0,
        ativo: true
    },
    lstObrigatorios: ['descricao'],
    lstObrigatoriosLabel: ['Descrição'],
});

async function limparInput(pObj) {
    if (pObj) {
        state.objetoAuxiliar = pObj;
    } else {
        state.objetoAuxiliar = {
            id: 0,
            ativo: true
        };
    }
}
</script>

<style scoped>
.lbl {
    max-width: 35%;
    line-height: 35px;
}
</style>